import { createAction, props } from '@ngrx/store';
import { BookingEntity } from '@resident-select/domain/booking';

export const CreatedBookingEvent = createAction(
  'CreatedBookingEvent',
  props<{ entities: BookingEntity[] }>()
);

export const UpdatedBookingEvent = createAction(
  'UpdatedBookingEvent',
  props<{ entities: BookingEntity[] }>()
);

export const AssignedVendorToBookingEvent = createAction(
  'AssignedVendorToBookingEvent',
  props<{ entities: BookingEntity[] }>()
);

export const AssignedVendorCompanyEvent = createAction(
  'AssignedVendorCompanyEvent',
  props<{ entities: BookingEntity[] }>()
);

export const GotAllBookingsEvent = createAction(
  'GotAllBookingsEvent',
  props<{ entities: BookingEntity[] }>()
);

export const GotAllBookingsByStatusEvent = createAction(
  'GotAllBookingsByStatusEvent',
  props<{ entities: BookingEntity[] }>()
);

export const GotAllBookingsBetweenDatesEvent = createAction(
  'GotAllBookingsBetweenDatesEvent',
  props<{ entities: BookingEntity[] }>()
);

export const GotAllBookingsByVendorDocumentEvent = createAction(
  'GotAllBookingsByVendorDocumentEvent',
  props<{ entities: BookingEntity[] }>()
);

export const GotAllBookingsByResidentAndStatusEvent = createAction(
  'GotAllBookingsByResidentAndStatusEvent',
  props<{ entities: BookingEntity[] }>()
);

export const GotAllBookingsBetweenDatesAndBuildingIdEvent = createAction(
  'GotAllBookingsBetweenDatesAndBuildingIdEvent',
  props<{ entities: BookingEntity[] }>()
);

export const GotAllBookingsByBuildingIdEvent = createAction(
  'GotAllBookingsByBuildingIdEvent',
  props<{ entities: BookingEntity[] }>()
);

export const GotAllBookingsByResidentEvent = createAction(
  'GotAllBookingsByResidentEvent',
  props<{ entities: BookingEntity[] }>()
);

export const ValidatedBookingAccessCodeEvent = createAction(
  'ValidatedBookingAccessCodeEvent',
  props<{ entities: BookingEntity[] }>()
);

export const InvalidBookingAccessCodeEvent = createAction(
  'InvalidBookingAccessCodeEvent',
  props<{ error: string }>()
);

export const DownloadedBookingsReportByBuildingIdEvent = createAction(
  'DownloadedBookingsReportByBuildingIdEvent',
  props<{ entities: any[] }>()
);

export const UpdatedBookingProcessStatusEvent = createAction(
  'UpdatedBookingProcessStatusEvent',
  props<{ entities: BookingEntity[] }>()
);
